"use client";

import { motion, type Variants } from "motion/react";

import { getVariants, IconWrapper, useAnimateIconContext, type IconProps } from "./icon";

type Volume2Props = IconProps<keyof typeof animations>;

const animations = {
  default: (() => {
    const animation: Record<string, Variants> = {
      path3: {},
    };

    for (let i = 1; i <= 2; i++) {
      animation[`path${i}`] = {
        initial: { opacity: 1, scale: 1 },
        animate: {
          opacity: 0,
          scale: 0,
          transition: {
            opacity: {
              duration: 0.2,
              ease: "easeInOut",
              repeat: 1,
              repeatType: "reverse",
              repeatDelay: 0.2,
              delay: 0.2 * (i - 1),
            },
            scale: {
              duration: 0.2,
              ease: "easeInOut",
              repeat: 1,
              repeatType: "reverse",
              repeatDelay: 0.2,
              delay: 0.2 * (i - 1),
            },
          },
        },
      };
    }

    return animation;
  })() satisfies Record<string, Variants>,
} as const;

function IconComponent({ size, ...props }: Volume2Props) {
  const { controls } = useAnimateIconContext();
  const variants = getVariants(animations);

  return (
    <motion.svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <motion.path
        d="M16 9a5 5 0 0 1 0 6"
        variants={variants["path1"]}
        initial="initial"
        animate={controls}
      />
      <motion.path
        d="M19.364 18.364a9 9 0 0 0 0-12.728"
        variants={variants["path2"]}
        initial="initial"
        animate={controls}
      />
      <motion.path
        d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z"
        variants={variants["path3"]}
        initial="initial"
        animate={controls}
      />
    </motion.svg>
  );
}

function Volume2(props: Volume2Props) {
  return <IconWrapper icon={IconComponent} {...props} />;
}

export {
  animations,
  Volume2,
  Volume2 as Volume2Icon,
  type Volume2Props as Volume2IconProps,
  type Volume2Props,
};
